import { BaseDTO } from '../global/base.dto';
import { AccountListDTO } from '../account/account-list.dto';

export class AddressDTO extends BaseDTO {

    address: string;

    city: string;

    zip: string;

    country: number;

    note: string;

    type: number;

    account: AccountListDTO;

}
